<template>
    <div>
        <h2>Normale Hinweise</h2>
        <columns property="infos" v-on:add="openForm" :filter="{ type: 'note', isTripDetail: false }">

            <column-item
                v-bind:update="{updatedBy: item.updatedBy, updatedAt: item.updatedAt}"
                :api="'/api/infos/' + item.id"
                slot-scope="{item}"
                v-on:edit="openForm(item)"
                v-on:delete="deleteItem('infos', item)"
                v-bind:label="importance(item)"
                class="is-flex has-merge-status"
            >
                <span v-if="showMergeStatus" class="merge-status is-corner" :class="mergeStatusClass(item.mergeStatus)" :title="mergeStatusLabel(item.mergeStatus)">{{ mergeStatusShort(item.mergeStatus) }}</span>
                <div class="content-grow">
                    <ul v-if="item.title">
                        <li><strong>{{item.title}}</strong></li>
                        <hr class="my-sm mb-sm" v-if="item.content || item.images.length > 0">
                    </ul>

                    <template v-if="item.images.length > 0">
                        <div class="columns is-multiline mb-0">
                            <div class="column is-one-third" v-for="image in item.images" v-bind:key="image.id">
                                <a v-bind:href="image.publicPath" target="_blank" class="image">
                                    <img v-bind:src="image.publicPath" v-bind:alt="image.title">
                                </a>
                            </div>
                        </div>
                        <hr class="my-sm mb-sm" v-if="item.content">
                    </template>

                    <p v-if="item.content" class="nl2br" v-html="item.content"></p>
                </div>

                <hr class="mt-sm mb-sm" v-if="item.sections.length > 0 || item.showInConnectedProviders || restrictedOtherServiceNames(item).length">

                <div class="buttons" style="padding-bottom: 20px" v-if="item.sections.length > 0 || item.showInConnectedProviders || restrictedOtherServiceNames(item).length">
                    <template v-if="item.sections">
                        <span class="button is-small" v-if="item.agency && api !== 'agencies' && item.showInConnectedProviders"> <a  style="color:#60A4AB" :href="`/agencies/${item.agency.id}`">von {{item.agency.name}}</a></span>
                        <span class="button is-small" v-if="api === 'agencies' && item.showInConnectedProviders"> <a style="color:#60A4AB">Gültig für verbundene Anbieter</a></span>
                        <span class="button is-small" v-for="section in item.sections" v-bind:key="section">{{sectionName(section)}}</span>
                        <span class="button is-small" v-if="restrictedOtherServiceNames(item).length"><a style="color:#60A4AB">nur {{restrictedOtherServiceNames(item).join(', ')}}</a></span>

                    </template>
                </div>

            </column-item>

            <info-form ref="form" slot="form" />
        </columns>
        <hr class="has-margin-top">
        <h2>Hinweise in den Reiseunterlagen</h2>
        <columns property="infos" v-on:add="openForm" :filter="{ type: 'note', isTripDetail: true }">

            <column-item
                v-bind:update="{updatedBy: item.updatedBy, updatedAt: item.updatedAt}"
                :api="'/api/infos/' + item.id"
                slot-scope="{item}"
                v-on:edit="openForm(item)"
                v-on:delete="deleteItem('infos', item)"
                v-bind:label="importance(item)"
                class="is-flex has-merge-status"
            >
                <span v-if="showMergeStatus" class="merge-status is-corner" :class="mergeStatusClass(item.mergeStatus)" :title="mergeStatusLabel(item.mergeStatus)">{{ mergeStatusShort(item.mergeStatus) }}</span>
                <div class="content-grow">
                    <ul v-if="item.title">
                        <li><strong>{{item.title}}</strong></li>
                        <hr class="my-sm mb-sm" v-if="item.content || item.images.length > 0">
                    </ul>

                    <template v-if="item.images.length > 0">
                        <div class="columns is-multiline mb-0">
                            <div class="column is-one-third" v-for="image in item.images" v-bind:key="image.id">
                                <a v-bind:href="image.publicPath" target="_blank" class="image">
                                    <img v-bind:src="image.publicPath" v-bind:alt="image.title">
                                </a>
                            </div>
                        </div>
                        <hr class="my-sm mb-sm" v-if="item.content">
                    </template>

                    <p v-if="item.content" class="nl2br" v-html="item.content"></p>
                </div>

                <hr class="mt-sm mb-sm">

                <div class="buttons" style="padding-bottom: 20px">
                    <span class="button is-small" v-if="item.agency && api !== 'agencies' && item.showInConnectedProviders"> <a  style="color:#60A4AB" :href="`/agencies/${item.agency.id}`">von {{item.agency.name}}</a></span>
                    <span class="button is-small" v-if="api === 'agencies' && item.showInConnectedProviders"> <a style="color:#60A4AB">Gültig für verbundene Anbieter</a></span>
                    <span class="button is-small" v-for="section in item.sections" v-bind:key="section">{{sectionName(section)}}</span>
                    <span class="button is-small" v-if="restrictedOtherServiceNames(item).length"><a style="color:#60A4AB">nur {{restrictedOtherServiceNames(item).join(', ')}}</a></span>
                    <span class="button is-small">Reiseunterlagen</span>
                </div>

            </column-item>

            <info-form ref="form" slot="form" />
        </columns>
    </div>

</template>

<script>
import has from 'lodash/has';

import { infoSections } from '@clientSpecific/utilities/variables';
import { getValueWithKey } from '@utilities/functions';
import { settings } from '@clientSpecific/utilities/settings';

import Mixin from '../tab';
import ValidForOtherServices from '../validForOtherServices';
import InfoForm from './Form';
import {getAxios} from "@api";

export default {
    mixins: [ Mixin, ValidForOtherServices ],
    components: { InfoForm },
    methods: {
        sectionName: function (section) {
            if (has(infoSections, section)) {
                return infoSections[section];
            }
            return section;
        },

        importance: function (item) {
            return getValueWithKey({key: item.importance, optionList: this.options.infos ? this.options.infos.importance : []})
        },

        mergeStatusLabel: function (status) {
            switch (status) {
                case 'welcome': return 'Welcome Tours';
                case 'buspaket': return 'Buspaket';
                case 'merged':
                case null:
                case undefined:
                    return 'Zusammengeführt';
                default: return status;
            }
        },

        mergeStatusShort: function (status) {
            switch (status) {
                case 'welcome': return 'W';
                case 'buspaket': return 'B';
                case 'merged':
                case null:
                case undefined:
                    return '';
                default: return '-';
            }
        },

        mergeStatusClass: function (status) {
            switch (status) {
                case 'welcome': return 'is-welcome';
                case 'buspaket': return 'is-buspaket';
                case 'merged':
                case null:
                case undefined:
                    return 'is-merged';
                default: return '';
            }
        },
    },
    computed: {
        showMergeStatus: function () {
            return settings.crud.mergeStatus;
        },

        api: function () {
            return this.$store.state.api; },

        getFilter () {
            return {
                ...['hotels', 'ferries', 'others', 'trains', 'airlines'].includes(this.api) && {'provider.id': this.item.id},
                ...this.api === 'agencies' && {'agency.id': this.item.id},
                ...this.api === 'clients' && {'client.id': this.item.id},
                ...this.api === 'destinations' && {'destination.id': this.item.id},
                ...this.api === 'areas' && {'area.id': this.item.id},
                ...this.api === 'places' && {'place.id': this.item.id},
                ...this.api === 'predefined_route_details' && {'predefinedRouteDetail.id': this.item.id},
                ...this.api === 'other_service_types' && {'otherServiceType.id': this.item.id},
            }
        }
    },
    mounted () {
        this.$store.state.data.infos = [];
        getAxios('infos', {_groups: ['image_read', 'translations', 'merge_status'], ...this.getFilter}).then(response => {
            this.$store.state.data.infos = response.data;
        })
    }
}
</script>
